<template>
	<div ref="editor"></div>
</template>

<script type="text/javascript">
	import '../../static/third/editor/ueditor.config';
	import '../../static/third/editor/ueditor.all.min';
	import '../../static/third/editor/lang/zh-cn/zh-cn';

	export default {
		data() {
			return {
				id: 'ueditorId_' + new Date().getTime()
			}
		},
		//定义属性
		props: {
			value: {
				type: String,
				default: null
			},
			config: {
				type: Object,
				default: function() {
					return {};
				}
			}
		},
		//监控内容变化
		watch: {
			value(val, oldval) {
				this.editor = UE.getEditor(this.id, this.config);
				if(null != val) {
					 this.editor.addListener( 'ready', function( editor ) {
					     editor.setContent(val);
					 } );
				}
			}
		},
		//挂载时候触发
		mounted() {
			this.$nextTick(function() {
				this.$refs.editor.id = this.id;
				this.editor = UE.getEditor(this.id, this.config);
				let obj_ = this;
				let editor_ = this.editor;
				editor_.addListener( 'ready', function() {
				     editor_.setContent(obj_.value);
				     editor_.addListener("contentChange", function() {
				     	let wordCount = editor_.getContentLength(true);
				     	let content = editor_.getContent();
				     	let plainTxt = editor_.getPlainTxt();
				     	obj_.$emit('input', {wordCount: wordCount, content: content, plainTxt: plainTxt});
				     });
				     obj_.$emit('ready', editor_);
				 });
			});
		}
	}
</script>

<style>
    body{
        /* background-color:#ff0000; */
    }
</style>


// WEBPACK FOOTER //
// ueditor.vue?40d79f7a